import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import axios from 'axios';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

// Registrar los componentes necesarios de Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

// Función para obtener el mes actual en español
const getCurrentMonth = () => {
  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  const currentMonth = new Date().getMonth();
  return months[currentMonth];
};

const ExpenseDoughnutChart = ({ selectedPOS }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Función para obtener los datos de gastos
  const fetchExpenseData = async () => {
    try {
      console.log('ExpenseDoughnutChart: Cargando datos para POS:', selectedPOS);
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No se encontró token de autenticación');
        setError('Error de autenticación');
        setLoading(false);
        return;
      }
      
      // Construir URL con el filtro de punto de venta
      let url = '/api/stats/monthly-expense-categories';
      // Siempre incluir el parámetro pointOfSaleId, incluso si es 'all'
      url += `?pointOfSaleId=${selectedPOS || 'all'}`;
      
      console.log('ExpenseDoughnutChart: Consultando URL:', url);
      console.log('ExpenseDoughnutChart: Parámetro de punto de venta:', selectedPOS);
      
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      
      console.log('Datos de gastos recibidos:', response.data);
      
      if (response.data && Array.isArray(response.data.labels) && Array.isArray(response.data.totals)) {
        if (response.data.labels.length > 0 && response.data.totals.length > 0) {
          setChartData({
            labels: response.data.labels,
            datasets: [
              {
                data: response.data.totals,
                backgroundColor: [
                  '#FF6384', // Rosa
                  '#36A2EB', // Azul
                  '#FFCE56', // Amarillo
                  '#4BC0C0', // Verde agua
                  '#9966FF', // Morado
                  '#FF9F40'  // Naranja
                ],
                hoverBackgroundColor: [
                  '#FF4394', // Rosa más oscuro
                  '#36A2EB', // Azul
                  '#FFCE56', // Amarillo
                  '#4BC0C0', // Verde agua
                  '#9966FF', // Morado
                  '#FF9F40'  // Naranja
                ]
              }
            ]
          });
          setError(null);
        } else {
          // Cuando no hay datos, simplemente establecer chartData a null sin establecer un error
          setChartData(null);
          setError(null);
        }
      } else {
        setChartData(null);
        setError('Formato de datos inválido');
        console.error('Formato de datos inválido:', response.data);
      }
    } catch (err) {
      console.error('Error al cargar datos de gastos:', err);
      setChartData(null);
      // Siempre establecer el mismo mensaje amigable, independientemente del error
      setError(null); // No establecer error para que se muestre el mensaje amigable
    } finally {
      setLoading(false);
    }
  };
  
  // Efecto para cargar datos cuando cambia selectedPOS
  useEffect(() => {
    console.log('ExpenseDoughnutChart: Efecto activado por cambio en selectedPOS:', selectedPOS);
    fetchExpenseData();
  }, [selectedPOS]);
  
  if (loading) {
    return <div className="charts-loading">Cargando gráfica de gastos...</div>;
  }
  
  // Si no hay datos de gastos, mostrar un mensaje informativo
  if (!chartData) {
    return <div className="charts-empty">Sin gastos registrados</div>;
  }
  
  // Solo mostrar errores reales si es necesario
  if (error) {
    return <div className="charts-empty">Sin gastos registrados</div>;
  }
  
  // Título de la gráfica con el mes actual y el punto de venta seleccionado
  const chartTitle = `Gastos de ${getCurrentMonth()} ${selectedPOS !== 'all' ? '(POS específico)' : '(Todos los POS)'}`;
  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 15,
          padding: 15
        }
      },
      title: {
        display: true,
        text: chartTitle,
        font: {
          size: 16
        }
      }
    }
  };
  
  return (
    <div className="chart-container">
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

export default ExpenseDoughnutChart;
